module.exports = __webpack_public_path__ + "img/cms-list-cards.6137d92c.svg";